import { gql, useMutation } from '@apollo/client'
export const USER_SENTENCES_QUERY = gql`
  query AllUserSentencesWithTranslations($username: String!, $lang: String!, $relationships: [String!]!) {
    allUserSentencesWithTranslations(username: $username, lang: $lang, relationships: $relationships) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`

export const ADD_USER_SENTENCE_MUTATION = gql`
  mutation AddUserSentence(
    $sourceText: String!
    $targetText: String!
    $sourceLang: String!
    $targetLang: String!
    $tags: [String]!
    $username: String!
    $sharedWith: [String]!
  ) {
    AddUserSentence(
      sourceText: $sourceText
      targetText: $targetText
      sourceLang: $sourceLang
      targetLang: $targetLang
      tags: $tags
      username: $username
      sharedWith: $sharedWith
    ) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`

export const USER_SENTENCES_WITH_TRANSLATIONS_QUERY = gql`
  query UserSentencesWithTranslations($username: String!, $lang: String!, $translationLang: String!) {
    userSentencesWithTranslations(username: $username, lang: $lang, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const SHARED_SENTENCES_WITH_TRANSLATIONS_QUERY = gql`
  query SharedSentencesWithTranslations($username: String!, $lang: String!, $translationLang: String!) {
    sharedSentencesWithTranslations(username: $username, lang: $lang, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`;
export const TATOEBA_SENTENCES_QUERY = gql`
  query SentenceWithTranslations($lang: String!, $word: String!, $translationLang: String!) {
    SentenceWithTranslations(lang: $lang, word: $word, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const GET_ALL_TRANSLATION_USER_SENTENCES = gql`
  query AllTranslationUserSentences($username: String!, $sourceLang: String) {
    allTranslationUserSentences(username: $username, sourceLang: $sourceLang) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
    }
  }
`
export const FLASHCARD_SENTENCES_QUERY = gql`
  query FlashcardSentences($username: String!, $sourceLang: String, $targetLang: String, $tags: [String]) {
    flashcardSentences(username: $username, sourceLang: $sourceLang, targetLang: $targetLang, tags: $tags) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
        imageUrl
        imageDescription
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
        imageUrl
        imageDescription
      }
    }
  }
`

// Record a mnemonic-image URL for a Word, keyed by (text, lang, username).
// Bytes are NOT sent through GraphQL — the frontend uploads to the image
// server first and only passes the resulting public URL here. This keeps the
// Render-hosted GraphQL server free of byte storage (its disk is ephemeral).
export const SET_WORD_IMAGE_MUTATION = gql`
  mutation SetWordImage($text: String!, $lang: String!, $username: String!, $imageUrl: String!, $description: String) {
    setWordImage(text: $text, lang: $lang, username: $username, imageUrl: $imageUrl, description: $description) {
      id
      text
      lang
      imageUrl
      imageDescription
      imageGeneratedAt
    }
  }
`

export const REMOVE_WORD_IMAGE_MUTATION = gql`
  mutation RemoveWordImage($text: String!, $lang: String!, $username: String!) {
    removeWordImage(text: $text, lang: $lang, username: $username) {
      id
      text
      lang
      imageUrl
    }
  }
`
export const GET_ALL_TRANSLATION_SHARED_SENTENCES = gql`
  query AllSharedSentencesWithTranslations($username: String!, $sourceLang: String) {
    allSharedSentencesWithTranslations(username: $username, sourceLang: $sourceLang) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
    }
  }
`
export const TATOEBA_SENTENCES_ALL_TRANSLATIONS_QUERY = gql`
  query SentenceWithAllTranslations($lang: String!, $word: String!) {
    SentenceWithAllTranslations(lang: $lang, word: $word) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const GET_INSPIRATIONS_QUERY = gql`
  query GetInspirations($username: String!) {
    getInspirations(username: $username) {
      identity
      labels
      properties {
        text
        lang
        username
      }
      elementId
    }
  }
`
export const SAVE_SENTENCE_MUTATION = gql`
  mutation SaveSentence($username: String!, $sentenceId: ID!) {
    SaveSentence(username: $username, sentenceId: $sentenceId) {
      id
      text
      lang
    }
  }
`
export const CHECK_SAVED_STATUS_QUERY = gql`
  query CheckSavedStatus($username: String!, $sourceSentenceId: ID!, $translationSentenceId: ID!) {
    checkSavedStatus(username: $username, sourceSentenceId: $sourceSentenceId, translationSentenceId: $translationSentenceId) {
      sourceSaved
      translationSaved
    }
  }
`
export const SAVE_SENTENCES_MUTATION = gql`
  mutation SaveSentences($username: String!, $sourceSentenceId: ID!, $translationSentenceId: ID!) {
    saveSentences(username: $username, sourceSentenceId: $sourceSentenceId, translationSentenceId: $translationSentenceId) {
      sourceSentence {
        id
      }
      sourceSaved
      translationSentence {
        id
      }
      translationSaved
    }
  }
`
export const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      user {
        id
        username
      }
    }
  }
`;
export const REGISTER_MUTATION = gql`
  mutation Register($username: String!, $password: String!, $role: String) {
    register(username: $username, password: $password, role: $role) {
      id
      username
      role
    }
  }
`;
export const GET_PROJECTS_QUERY = gql`
  query GetProjects($username: String!) {
    getProjects(username: $username) {
      identity
      labels
      properties {
        title
        username
      }
      elementId
    }
  }
`;
export const GET_TASKS_BY_PROJECT_QUERY = gql`
  query GetTasksByProject($projectName: String!) {
    getTasksByProject(projectName: $projectName) {
      task {
        identity
        labels
        properties {
          title
          type
          description
          priority
          assignee
          timeBudget
          timeSpent
          dueDate
          dateAdded
          dateLastModified
          username
          project
          personal
          inFlow
          parentId
          subtaskOrder
        }
        elementId
        assignedTo {
          identity
          properties {
            username
          }
        }
      }
      status
    }
  }
`;
export const GET_TASKS_QUERY = gql`
query GetTasks($username: String!) {
  getTasks(username: $username) {
    identity
    status
    properties {
      title
      type
      description
      priority
      timeBudget
      timeSpent
      project
      assignee
      dueDate
      parentId
    }
    elementId
  }
}
`;
export const UPDATE_TASK_MUTATION = gql`
  mutation UpdateTask($identity: ID!, $input: TaskUpdateInput!) {
    updateTask(identity: $identity, input: $input) {
      identity
      properties {
        timeSpent
      }
    }
  }
`;
export const DELETE_TASK_MUTATION = gql`
  mutation DeleteTask($identity: ID!) {
    deleteTask(identity: $identity)
  }
`;
export const ADD_NOTE_MUTATION = gql`
  mutation AddNote(
    $title: String!
    $mapData: String!
    $linkedProject: String
    $linkedTaskId: String
    $username: String!
  ) {
    addNote(input: {
      title: $title
      mapData: $mapData
      linkedProject: $linkedProject
      linkedTaskId: $linkedTaskId
      username: $username
    }) {
      identity
      elementId
      properties {
        title
        mapData
        linkedProject
        username
        dateAdded
      }
    }
  }
`;
export const GET_NOTES_QUERY = gql`
  query GetNotes($username: String!, $linkedProject: String, $linkedTaskId: String) {
    getNotes(username: $username, linkedProject: $linkedProject, linkedTaskId: $linkedTaskId) {
      identity
      elementId
      properties {
        title
        mapData
        linkedProject
        username
        dateAdded
        dateLastModified
      }
    }
  }
`;

export const ADD_MEETING_WITH_CONTENT_MUTATION = gql`
  mutation AddMeetingWithContent($input: AddMeetingWithContentInput!) {
    addMeetingWithContent(input: $input) {
      meeting {
        identity
        properties {
          title
          type
        }
      }
      sentenceCount
      wordCount
      taskCount
    }
  }
`;

export const DELETE_MEETING_MUTATION = gql`
  mutation DeleteMeeting($identity: ID!) {
    deleteMeeting(identity: $identity)
  }
`;

export const ADD_MEETING_SENTENCE_MUTATION = gql`
  mutation AddMeetingSentence($input: AddMeetingSentenceInput!) {
    addMeetingSentence(input: $input) {
      source { id text lang }
      target { id text lang }
    }
  }
`;

export const ADD_MEETING_WORD_MUTATION = gql`
  mutation AddMeetingWord($input: AddMeetingWordInput!) {
    addMeetingWord(input: $input) {
      source { id text lang imageUrl imageDescription }
      target { id text lang }
    }
  }
`;

export const DELETE_MEETING_SENTENCE_MUTATION = gql`
  mutation DeleteMeetingSentence($sentenceId: ID!) {
    deleteMeetingSentence(sentenceId: $sentenceId)
  }
`;

export const DELETE_MEETING_WORD_MUTATION = gql`
  mutation DeleteMeetingWord($meetingId: ID!, $wordId: ID!) {
    deleteMeetingWord(meetingId: $meetingId, wordId: $wordId)
  }
`;

export const UPDATE_MEETING_DATE_MUTATION = gql`
  mutation UpdateMeetingDate($identity: ID!, $meetingDate: String!) {
    updateMeetingDate(identity: $identity, meetingDate: $meetingDate) {
      identity
      properties {
        title
        type
        meetingDate
        dateAdded
        dateLastModified
      }
    }
  }
`;

export const GET_MEETINGS_QUERY = gql`
  query GetMeetings($username: String!) {
    getMeetings(username: $username) {
      identity
      labels
      properties {
        title
        type
        description
        username
        meetingDate
        dateAdded
        dateLastModified
        lessonData
      }
      elementId
    }
  }
`;

// Lesson proficiency (server: schema/proficiency.js): the latest answer to each
// exercise item, and the weighted percentage it adds up to.
export const RECORD_LESSON_RESULTS_MUTATION = gql`
  mutation RecordLessonResults($meetingId: ID!, $results: [LessonResultInput!]!) {
    recordLessonResults(meetingId: $meetingId, results: $results) { meetingId pct sentencesRight sentencesTotal }
  }
`

export const MY_LESSON_PROGRESS_QUERY = gql`
  query MyLessonProgress($ids: [ID!]!) {
    myLessonProgress(meetingIds: $ids) { meetingId pct sentencesRight sentencesTotal }
  }
`

export const RECORD_PRACTICE_MUTATION = gql`
  mutation RecordPractice($itemId: ID!, $itemType: String!, $isCorrect: Boolean!) {
    recordPractice(itemId: $itemId, itemType: $itemType, isCorrect: $isCorrect) {
      timesPracticed
      timesCorrect
      lastPracticedAt
      nextReviewAt
      interval
    }
  }
`

export const GET_MEETING_WITH_CONTENT_QUERY = gql`
  query GetMeetingWithContent($identity: ID!) {
    getMeetingWithContent(identity: $identity) {
      meeting {
        identity
        labels
        properties {
          title
          type
          description
          username
          meetingDate
          dateAdded
          dateLastModified
          lessonData
        }
        elementId
      }
      sentences {
        source {
          id
          text
          lang
        }
        target {
          id
          text
          lang
        }
      }
      words {
        source {
          id
          text
          lang
          imageUrl
          imageDescription
        }
        target {
          id
          text
          lang
        }
      }
      tasks {
        id
        title
        type
        description
        priority
      }
    }
  }
`;

export const ADD_PARAGRAPH_WITH_CONTENT_MUTATION = gql`
  mutation AddParagraphWithContent($input: AddParagraphWithContentInput!) {
    addParagraphWithContent(input: $input) {
      paragraph {
        identity
        properties {
          title
          text
          lang
          posMap
        }
      }
      sentenceCount
      wordCount
    }
  }
`;

export const GET_PARAGRAPHS_QUERY = gql`
  query GetParagraphs($username: String!, $lang: String) {
    getParagraphs(username: $username, lang: $lang) {
      identity
      labels
      properties {
        title
        text
        lang
        posMap
        username
        dateAdded
        dateLastModified
      }
      elementId
    }
  }
`;

export const GET_PARAGRAPH_WITH_CONTENT_QUERY = gql`
  query GetParagraphWithContent($identity: ID!, $username: String) {
    getParagraphWithContent(identity: $identity, username: $username) {
      paragraph {
        identity
        labels
        properties {
          title
          text
          lang
          posMap
          username
          dateAdded
          dateLastModified
        }
        elementId
      }
      sentences {
        source {
          id
          text
          lang
          order
        }
        target {
          id
          text
          lang
        }
      }
      words {
        source {
          id
          text
          lang
          timesPracticed
          timesCorrect
          lastPracticedAt
          imageUrl
          imageDescription
        }
        target {
          id
          text
          lang
        }
      }
    }
  }
`;

export const DELETE_PARAGRAPH_MUTATION = gql`
  mutation DeleteParagraph($identity: ID!) {
    deleteParagraph(identity: $identity)
  }
`;

export const ADD_PARAGRAPH_WORD_LOOKUP_MUTATION = gql`
  mutation AddParagraphWordLookup(
    $username: String!
    $paragraphId: ID!
    $word: String!
    $translation: String!
    $lang: String!
  ) {
    addParagraphWordLookup(
      username: $username
      paragraphId: $paragraphId
      word: $word
      translation: $translation
      lang: $lang
    ) {
      id
      text
      lang
    }
  }
`;
// ─── Media ────────────────────────────────────────────────────────────
// Persistent project store for the media workflow. The Mac mini owns
// the filesystem; this module owns the Neo4j metadata + check-out registry.

export const LIST_SHOOTS_QUERY = gql`
  query ListShoots($project: String) {
    listShoots(project: $project) {
      identity
      properties {
        name
        slug
        project
        projectSlug
        notes
        shootDate
        username
        createdAt
        dateLastModified
        visibility
        checkedOutBy
        checkedOutAt
        assetCount
      }
    }
  }
`;

export const GET_SHOOT_QUERY = gql`
  query GetShoot($identity: ID!) {
    getShoot(identity: $identity) {
      shoot {
        identity
        properties {
          name
          slug
          project
          projectSlug
          notes
          shootDate
          username
          createdAt
          dateLastModified
          visibility
          checkedOutBy
          checkedOutAt
          assetCount
        }
      }
      assets {
        identity
        path
        filename
        date
        device
        kind
        size
        mtime
        thumbnailUrl
        fileUrl
        downloadUrl
        visibility
        uploadedBy
        hash
        sidecars { path filename kind size downloadUrl versionCount editVersions cameraVersions editors sources }
      }
    }
  }
`;

// Signed URLs for every original in a shoot, for pulling it to a local drive.
export const GET_SHOOT_DOWNLOAD_QUERY = gql`
  query GetShootDownload($identity: ID!) {
    getShootDownload(identity: $identity) {
      shoot
      fileCount
      totalBytes
      expiresAt
      files { url output filename size }
    }
  }
`;


// ─── Deliveries ──────────────────────────────────────────────────────────────
// A fixed set of finished files handed to a client. Lives in
// deliveries/<project>/<delivery>/ and is what an external login will see.
//
// Written out in full rather than composed from shared fragments: the query
// validator parses these files statically, so an interpolated \${...} would
// make them unparseable and therefore unchecked.

export const LIST_DELIVERIES_QUERY = gql`
  query ListDeliveries($project: String) {
    listDeliveries(project: $project) {
      identity
      properties {
      name
      slug
      project
      projectSlug
      deliveredOn
      notes
      username
      createdAt
      dateLastModified
      visibility
      path
      fileCount
      totalBytes
      }
    }
  }
`;

export const GET_DELIVERY_QUERY = gql`
  query GetDelivery($identity: ID!) {
    getDelivery(identity: $identity) {
      delivery {
        identity
        properties {
        name
        slug
        project
        projectSlug
        deliveredOn
        notes
        username
        createdAt
        dateLastModified
        visibility
        path
        fileCount
        totalBytes
        }
      }
    files {
      identity
      path
      filename
      kind
      size
      mtime
      thumbnailUrl
      fileUrl
      downloadUrl
    }
    }
  }
`;

export const CREATE_DELIVERY_MUTATION = gql`
  mutation CreateDelivery($input: CreateDeliveryInput!) {
    createDelivery(input: $input) {
      identity
      properties {
      name
      slug
      project
      projectSlug
      deliveredOn
      notes
      username
      createdAt
      dateLastModified
      visibility
      path
      fileCount
      totalBytes
      }
    }
  }
`;

// Rescan the folder after uploading, and link each export to its original.
export const INDEX_DELIVERY_MUTATION = gql`
  mutation IndexDelivery($identity: ID!) {
    indexDelivery(identity: $identity) {
      delivery {
        identity
        properties {
        name
        slug
        project
        projectSlug
        deliveredOn
        notes
        username
        createdAt
        dateLastModified
        visibility
        path
        fileCount
        totalBytes
        }
      }
    files {
      identity
      path
      filename
      kind
      size
      mtime
      thumbnailUrl
      fileUrl
      downloadUrl
    }
    }
  }
`;

export const SET_DELIVERY_VISIBILITY_MUTATION = gql`
  mutation SetDeliveryVisibility($identity: ID!, $visibility: String!) {
    setDeliveryVisibility(identity: $identity, visibility: $visibility) {
      identity
      properties {
      name
      slug
      project
      projectSlug
      deliveredOn
      notes
      username
      createdAt
      dateLastModified
      visibility
      path
      fileCount
      totalBytes
      }
    }
  }
`;

export const DELETE_DELIVERY_MUTATION = gql`
  mutation DeleteDelivery($identity: ID!) {
    deleteDelivery(identity: $identity)
  }
`;

export const GET_DELIVERY_DOWNLOAD_QUERY = gql`
  query GetDeliveryDownload($identity: ID!) {
    getDeliveryDownload(identity: $identity) {
      shoot
      fileCount
      totalBytes
      expiresAt
      files { url output filename size }
    }
  }
`;

export const CREATE_SHOOT_MUTATION = gql`
  mutation CreateShoot($input: CreateShootInput!) {
    createShoot(input: $input) {
      identity
      properties { name slug project shootDate visibility }
    }
  }
`;

export const ADD_ASSETS_TO_SHOOT_MUTATION = gql`
  mutation AddAssetsToShoot($identity: ID!, $paths: [String!]!) {
    addAssetsToShoot(identity: $identity, paths: $paths)
  }
`;

export const REMOVE_ASSET_FROM_SHOOT_MUTATION = gql`
  mutation RemoveAssetFromShoot($identity: ID!, $path: String!) {
    removeAssetFromShoot(identity: $identity, path: $path)
  }
`;

export const UPDATE_SHOOT_DATE_MUTATION = gql`
  mutation UpdateShootDate($identity: ID!, $shootDate: String!) {
    updateShootDate(identity: $identity, shootDate: $shootDate) {
      identity
      properties { shootDate dateLastModified }
    }
  }
`;

export const SET_SHOOT_VISIBILITY_MUTATION = gql`
  mutation SetShootVisibility($identity: ID!, $visibility: String!) {
    setShootVisibility(identity: $identity, visibility: $visibility) {
      identity
      properties { visibility }
    }
  }
`;

export const CHECK_OUT_SHOOT_MUTATION = gql`
  mutation CheckOutShoot($identity: ID!) {
    checkOutShoot(identity: $identity) {
      identity
      properties { checkedOutBy checkedOutAt }
    }
  }
`;

export const CHECK_IN_SHOOT_MUTATION = gql`
  mutation CheckInShoot($identity: ID!) {
    checkInShoot(identity: $identity) {
      identity
      properties { checkedOutBy checkedOutAt }
    }
  }
`;

export const DELETE_SHOOT_MUTATION = gql`
  mutation DeleteShoot($identity: ID!) {
    deleteShoot(identity: $identity)
  }
`;

export const GET_MEDIA_LIBRARY_QUERY = gql`
  query GetMediaLibrary($username: String, $limit: Int, $cursor: String) {
    getMediaLibrary(username: $username, limit: $limit, cursor: $cursor) {
      nextCursor
      totalDays
      totalAssets
      returnedAssets
      days {
        date
        devices {
          device
          assets {
            identity
            path
            filename
            date
            device
            kind
            size
            mtime
            thumbnailUrl
            fileUrl
            downloadUrl
            visibility
            uploadedBy
            hash
            sidecars { path filename kind size downloadUrl versionCount editVersions cameraVersions editors sources }
            projects
          }
        }
      }
    }
  }
`;

// Signed URLs for an arbitrary selection out of the library, valid 12h rather
// than the 30 minutes a browsing URL carries. Sidecars of the chosen files come
// too -- the server adds them, since the grid nests them under their parent and
// never offers them for selection.
// Every saved state of one sidecar, newest first. Two people editing the same
// raw both save a .xmp -- the second becomes current, the first is archived --
// and this is how you get at either.
export const SIDECAR_VERSIONS_QUERY = gql`
  query SidecarVersions($path: String!) {
    sidecarVersions(path: $path) {
      filename
      savedAt
      uploadedBy
      source
      editingWork
      size
      isCurrent
      downloadUrl
    }
  }
`;

export const GET_SELECTION_DOWNLOAD_QUERY = gql`
  query GetSelectionDownload($paths: [String!]!, $withEdits: Boolean) {
    getSelectionDownload(paths: $paths, withEdits: $withEdits) {
      shoot
      fileCount
      totalBytes
      expiresAt
      files { url output filename size }
    }
  }
`;

export const ATTACH_MEDIA_ASSETS_MUTATION = gql`
  mutation AttachMediaAssets($paths: [String!]!, $project: String!, $username: String!) {
    attachMediaAssetsToProject(paths: $paths, project: $project, username: $username)
  }
`;

export const ATTACH_TASK_OUTPUTS_MUTATION = gql`
  mutation AttachTaskOutputs($taskId: ID!, $paths: [String!]!, $username: String!) {
    attachTaskOutputs(taskId: $taskId, paths: $paths, username: $username)
  }
`;

export const DETACH_TASK_OUTPUT_MUTATION = gql`
  mutation DetachTaskOutput($taskId: ID!, $path: String!) {
    detachTaskOutput(taskId: $taskId, path: $path)
  }
`;

export const GET_TASK_OUTPUTS_QUERY = gql`
  query GetTaskOutputs($taskId: ID!) {
    getTaskOutputs(taskId: $taskId) {
      identity
      path
      filename
      kind
      thumbnailUrl
    }
  }
`;

export const GET_TASKS_FOR_MEDIA_PATHS_QUERY = gql`
  query GetTasksForMediaPaths($paths: [String!]!) {
    getTasksForMediaPaths(paths: $paths) {
      path
      tasks { id title }
    }
  }
`;

export const DETACH_MEDIA_ASSET_MUTATION = gql`
  mutation DetachMediaAsset($path: String!, $project: String!) {
    detachMediaAssetFromProject(path: $path, project: $project)
  }
`;

// Who the stored token says we are. The username lives in React state and is
// lost on refresh while the token survives in localStorage, so this is how the
// UI recovers identity instead of appearing logged out.
export const ME_QUERY = gql`
  query Me {
    me {
      id
      username
      role
    }
  }
`;

// Permission to upload into one folder, valid 15 minutes. Ask for this
// immediately before uploading, then POST the files to the returned url.
// Replaces the shared token that used to ship in the bundle.
export const CREATE_UPLOAD_GRANT_MUTATION = gql`
  mutation CreateUploadGrant($path: String!) {
    createUploadGrant(path: $path) {
      url
      path
      expiresAt
    }
  }
`;

export const SET_MEDIA_ASSET_VISIBILITY_MUTATION = gql`
  mutation SetMediaAssetVisibility($paths: [String!]!, $visibility: String!) {
    setMediaAssetVisibility(paths: $paths, visibility: $visibility)
  }
`;

// ─── Task groups ─────────────────────────────────────────────────────────────

export const ADD_TASK_GROUP_WITH_TASKS_MUTATION = gql`
  mutation AddTaskGroupWithTasks($input: AddTaskGroupWithTasksInput!) {
    addTaskGroupWithTasks(input: $input) {
      group {
        identity
        properties { title project }
      }
      tasks {
        identity
        properties { title type assignee priority }
      }
    }
  }
`;

// ─── Journal ─────────────────────────────────────────────────────────────────

export const GET_JOURNAL_ENTRIES_QUERY = gql`
  query GetJournalEntries($username: String!, $tag: String, $from: String, $to: String, $includeArchived: Boolean, $limit: Int) {
    getJournalEntries(username: $username, tag: $tag, from: $from, to: $to, includeArchived: $includeArchived, limit: $limit) {
      identity
      properties {
        username
        body
        title
        mood
        tags
        source
        archived
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_REFLECTIONS_QUERY = gql`
  query GetReflections($username: String!, $linkedEntryId: ID, $limit: Int) {
    getReflections(username: $username, linkedEntryId: $linkedEntryId, limit: $limit) {
      identity
      properties {
        username
        text
        model
        mode
        createdAt
      }
    }
  }
`;

export const ADD_JOURNAL_ENTRY_MUTATION = gql`
  mutation AddJournalEntry($input: JournalEntryInput!) {
    addJournalEntry(input: $input) {
      identity
      properties {
        username
        body
        title
        mood
        tags
        source
        archived
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_JOURNAL_ENTRY_MUTATION = gql`
  mutation UpdateJournalEntry($identity: ID!, $input: JournalEntryUpdateInput!) {
    updateJournalEntry(identity: $identity, input: $input) {
      identity
      properties {
        body
        title
        mood
        tags
        archived
        updatedAt
      }
    }
  }
`;

export const DELETE_JOURNAL_ENTRY_MUTATION = gql`
  mutation DeleteJournalEntry($identity: ID!) {
    deleteJournalEntry(identity: $identity)
  }
`;

export const ADD_REFLECTION_MUTATION = gql`
  mutation AddReflection($input: ReflectionInput!) {
    addReflection(input: $input) {
      identity
      properties {
        username
        text
        model
        mode
        createdAt
      }
    }
  }
`;

export const DELETE_REFLECTION_MUTATION = gql`
  mutation DeleteReflection($identity: ID!) {
    deleteReflection(identity: $identity)
  }
`;

// ─── Client access ───────────────────────────────────────────────────────────
// A client account sees only the deliveries marked 'client' in the projects it
// has been granted. Everything else in the media layer refuses it outright.

export const MY_ACCESS_QUERY = gql`
  query MyAccess {
    myAccess {
      username
      role
      projects {
        username
        project
        canSeeOriginals
        grantedBy
        grantedAt
      }
    }
  }
`;

export const MY_DELIVERIES_QUERY = gql`
  query MyDeliveries {
    myDeliveries {
      identity
      properties {
        name
        slug
        project
        projectSlug
        deliveredOn
        notes
        username
        createdAt
        dateLastModified
        visibility
        path
        fileCount
        totalBytes
      }
    }
  }
`;

export const LIST_PROJECT_ACCESS_QUERY = gql`
  query ListProjectAccess($project: String!) {
    listProjectAccess(project: $project) {
      username
      project
      canSeeOriginals
      grantedBy
      grantedAt
    }
  }
`;

export const CREATE_CLIENT_ACCOUNT_MUTATION = gql`
  mutation CreateClientAccount($username: String!, $password: String!, $project: String!, $canSeeOriginals: Boolean) {
    createClientAccount(username: $username, password: $password, project: $project, canSeeOriginals: $canSeeOriginals) {
      id
      username
      role
    }
  }
`;

export const GRANT_PROJECT_ACCESS_MUTATION = gql`
  mutation GrantProjectAccess($username: String!, $project: String!, $canSeeOriginals: Boolean) {
    grantProjectAccess(username: $username, project: $project, canSeeOriginals: $canSeeOriginals) {
      username
      project
      canSeeOriginals
    }
  }
`;

export const REVOKE_PROJECT_ACCESS_MUTATION = gql`
  mutation RevokeProjectAccess($username: String!, $project: String!) {
    revokeProjectAccess(username: $username, project: $project)
  }
`;

export const SET_CLIENT_PASSWORD_MUTATION = gql`
  mutation SetClientPassword($username: String!, $password: String!) {
    setClientPassword(username: $username, password: $password)
  }
`;

// ── Learner profile (user node + native / learning languages) ────────────────
const USER_PROFILE_FIELDS = `
  user { id username role name gender birthYear occupation homeCity homeCountry profile }
  native { code name }
  learning { code name level startedAt active }
`;

export const GET_USER_PROFILE_QUERY = gql`
  query GetUserProfile {
    getUserProfile { ${USER_PROFILE_FIELDS} }
  }
`;

export const UPDATE_USER_PROFILE_MUTATION = gql`
  mutation UpdateUserProfile($username: String!, $input: UserProfileInput!) {
    updateUserProfile(username: $username, input: $input) { ${USER_PROFILE_FIELDS} }
  }
`;

export const SET_NATIVE_LANGUAGES_MUTATION = gql`
  mutation SetNativeLanguages($username: String!, $languages: [LanguageInput!]!) {
    setNativeLanguages(username: $username, languages: $languages) { ${USER_PROFILE_FIELDS} }
  }
`;

export const SET_LEARNING_LANGUAGE_MUTATION = gql`
  mutation SetLearningLanguage($username: String!, $code: String!, $name: String, $level: String) {
    setLearningLanguage(username: $username, code: $code, name: $name, level: $level) { ${USER_PROFILE_FIELDS} }
  }
`;

export const REMOVE_LEARNING_LANGUAGE_MUTATION = gql`
  mutation RemoveLearningLanguage($username: String!, $code: String!) {
    removeLearningLanguage(username: $username, code: $code) { ${USER_PROFILE_FIELDS} }
  }
`;

// ── Spaced-repetition read side: items due for review ────────────────────────
export const GET_DUE_ITEMS_QUERY = gql`
  query GetDueItems($lang: String, $limit: Int) {
    getDueItems(lang: $lang, limit: $limit) {
      id text lang itemType
      translationId translationText translationLang
      timesPracticed timesCorrect nextReviewAt
    }
  }
`;

// Due items per language being learned (native side excluded) — drives the
// language chips in Review Due and the count on the dashboard.
export const GET_DUE_COUNTS_QUERY = gql`
  query GetDueCounts {
    getDueCounts {
      lang count
    }
  }
`;

// Per-letter results from the alphabet drills — which letters a learner keeps
// getting wrong. The board highlights them; the tests lean toward them.
export const LETTER_STATS_QUERY = gql`
  query LetterStats($lang: String!) {
    letterStats(lang: $lang) {
      letter right wrong streak lastAt lastWrongAt
    }
  }
`;
export const RECORD_LETTER_MUTATION = gql`
  mutation RecordLetter($lang: String!, $letter: String!, $correct: Boolean!) {
    recordLetter(lang: $lang, letter: $letter, correct: $correct) {
      letter right wrong streak lastAt lastWrongAt
    }
  }
`;

// ── Language "tech tree": topics, prerequisites, per-user completion ──────────
export const GET_LANGUAGE_TREE_QUERY = gql`
  query GetLanguageTree($langCode: String!) {
    getLanguageTree(langCode: $langCode) {
      id slug title level order blurb requires completed lessonMeetingId
    }
  }
`;

export const SEED_CURRICULUM_MUTATION = gql`
  mutation SeedCurriculum($langCode: String!, $name: String, $topics: [TopicSeedInput!]!) {
    seedCurriculum(langCode: $langCode, name: $name, topics: $topics)
  }
`;

export const COMPLETE_TOPIC_MUTATION = gql`
  mutation CompleteTopic($topicId: ID!) {
    completeTopic(topicId: $topicId)
  }
`;

export const ATTACH_LESSON_TO_TOPIC_MUTATION = gql`
  mutation AttachLessonToTopic($topicId: ID!, $meetingId: ID!) {
    attachLessonToTopic(topicId: $topicId, meetingId: $meetingId)
  }
`;
// The fields of a practice result shared with a teacher.
const DRILL_RESULT_FIELDS = `id student teacher title language mode total perfect pct details sharedAt comment reviewedAt`

// ── The teacher's view of one student ────────────────────────────────────────
// Every one of these is refused by the server unless the student has added you
// with your teaching code. They return learning data for one language only —
// no profile facts, no journal, no notes.
export const STUDENT_LANGUAGES_QUERY = gql`
  query StudentLanguages($student: String!) {
    studentLanguages(student: $student) { code name level startedAt active }
  }
`;

export const STUDENT_BRIEF_QUERY = gql`
  query StudentBrief($student: String!, $lang: String!) {
    studentBrief(student: $student, lang: $lang) {
      student lang lastPracticedAt itemsPracticed dueNow
      topicsCompleted topicsTotal nextLevel
      homeworkAssigned homeworkSubmitted
      lastHomeworkTitle lastHomeworkStatus lastHomeworkAt
    }
  }
`;

export const STUDENT_WEAK_ITEMS_QUERY = gql`
  query StudentWeakItems($student: String!, $lang: String!, $limit: Int) {
    studentWeakItems(student: $student, lang: $lang, limit: $limit) {
      id text lang itemType translationText
      timesPracticed timesCorrect pct lastPracticedAt
    }
  }
`;

export const STUDENT_LETTER_STATS_QUERY = gql`
  query StudentLetterStats($student: String!, $lang: String!) {
    studentLetterStats(student: $student, lang: $lang) {
      letter right wrong streak lastAt lastWrongAt
    }
  }
`;

export const STUDENT_DRILL_RESULTS_QUERY = gql`
  query StudentDrillResults($student: String!, $limit: Int) {
    studentDrillResults(student: $student, limit: $limit) { ${DRILL_RESULT_FIELDS} }
  }
`;

export const STUDENT_TREE_QUERY = gql`
  query StudentTree($student: String!, $langCode: String!) {
    studentTree(student: $student, langCode: $langCode) {
      id slug title level order blurb requires completed lessonMeetingId
    }
  }
`;

// ── Homework: assign lessons, speaking answers (speech-to-text), teacher review ──
const SUBMISSION_FIELDS = `id answers { index prompt text } submittedAt updatedAt comment reviewedAt`

// Homework and teaching. None of these takes a username any more: the server
// reads the acting user from the bearer token, so a client can only ever act
// as itself. Passing one would be ignored at best and rejected at worst.
export const MY_ASSIGNMENTS_QUERY = gql`
  query MyAssignments {
    myAssignments {
      meetingId title teacher student assignedAt due status
      submission { ${SUBMISSION_FIELDS} }
    }
  }
`

export const MY_ASSIGNED_LESSONS_QUERY = gql`
  query MyAssignedLessons {
    myAssignedLessons {
      meetingId title due
      students { student assignedAt due status submission { ${SUBMISSION_FIELDS} } }
    }
  }
`

export const MY_SUBMISSION_QUERY = gql`
  query MySubmission($meetingId: ID!) {
    mySubmission(meetingId: $meetingId) { ${SUBMISSION_FIELDS} }
  }
`

// ── Teaching links ──────────────────────────────────────────────────────────
// A teacher shares a short code; the student types it. The student performs
// the linking, so consent is explicit, and no one is ever found by browsing
// usernames (which is what the old searchUsers allowed, to anyone at all).
export const MY_STUDENTS_QUERY = gql`
  query MyStudents { myStudents { username since langs } }
`
export const MY_TEACH_CODE_QUERY = gql`
  query MyTeachCode { myTeachCode }
`
// What the student sees and sets: which languages each teacher may look at.
export const MY_TEACHER_LINKS_QUERY = gql`
  query MyTeacherLinks { myTeacherLinks { username since langs } }
`
export const LINK_TEACHER_MUTATION = gql`
  mutation LinkTeacherByCode($code: String!, $langs: [String!]) {
    linkTeacherByCode(code: $code, langs: $langs)
  }
`
export const SET_TEACHER_LANGUAGES_MUTATION = gql`
  mutation SetTeacherLanguages($teacher: String!, $langs: [String!]!) {
    setTeacherLanguages(teacher: $teacher, langs: $langs)
  }
`
export const REGENERATE_TEACH_CODE_MUTATION = gql`
  mutation RegenerateTeachCode { regenerateTeachCode }
`
export const UNLINK_TEACHER_MUTATION = gql`
  mutation UnlinkTeacher($teacher: String!) { unlinkTeacher(teacher: $teacher) }
`
export const REMOVE_STUDENT_MUTATION = gql`
  mutation RemoveStudent($student: String!) { removeStudent(student: $student) }
`

export const ASSIGN_LESSON_MUTATION = gql`
  mutation AssignLesson($meetingId: ID!, $students: [String!]!, $due: String) {
    assignLesson(meetingId: $meetingId, students: $students, due: $due)
  }
`

export const UNASSIGN_LESSON_MUTATION = gql`
  mutation UnassignLesson($meetingId: ID!, $student: String!) {
    unassignLesson(meetingId: $meetingId, student: $student)
  }
`

export const SUBMIT_SPEAKING_ANSWERS_MUTATION = gql`
  mutation SubmitSpeakingAnswers($meetingId: ID!, $answers: [SpeakingAnswerInput!]!) {
    submitSpeakingAnswers(meetingId: $meetingId, answers: $answers) { ${SUBMISSION_FIELDS} }
  }
`

export const REVIEW_SUBMISSION_MUTATION = gql`
  mutation ReviewSubmission($submissionId: ID!, $comment: String!) {
    reviewSubmission(submissionId: $submissionId, comment: $comment) { id comment reviewedAt }
  }
`

// ── Sharing a finished practice set with a teacher ──────────────────────────

export const MY_TEACHERS_QUERY = gql`
  query MyTeachers { myTeachers }
`

export const DRILL_RESULTS_FOR_ME_QUERY = gql`
  query DrillResultsForMe($limit: Int) {
    drillResultsForMe(limit: $limit) { ${DRILL_RESULT_FIELDS} }
  }
`

export const MY_SHARED_RESULTS_QUERY = gql`
  query MySharedResults($limit: Int) {
    mySharedResults(limit: $limit) { ${DRILL_RESULT_FIELDS} }
  }
`

export const SHARE_DRILL_RESULT_MUTATION = gql`
  mutation ShareDrillResult($teacher: String!, $input: DrillResultInput!) {
    shareDrillResult(teacher: $teacher, input: $input) { ${DRILL_RESULT_FIELDS} }
  }
`

export const COMMENT_DRILL_RESULT_MUTATION = gql`
  mutation CommentDrillResult($resultId: ID!, $comment: String!) {
    commentDrillResult(resultId: $resultId, comment: $comment) { id comment reviewedAt }
  }
`

// ── Teacher notes and "things I want to say" ────────────────────────────────
const TEACHER_NOTE_FIELDS = `id teacher student lang text createdAt updatedAt lessonStatus`
const SAY_ITEM_FIELDS = `id text sourceLang lang translation createdAt`

export const STUDENT_NOTES_QUERY = gql`
  query StudentNotes($student: String!, $lang: String!) {
    studentNotes(student: $student, lang: $lang) { ${TEACHER_NOTE_FIELDS} }
  }
`;
export const ADD_TEACHER_NOTE_MUTATION = gql`
  mutation AddTeacherNote($student: String!, $lang: String!, $text: String!) {
    addTeacherNote(student: $student, lang: $lang, text: $text) { ${TEACHER_NOTE_FIELDS} }
  }
`;
export const UPDATE_TEACHER_NOTE_MUTATION = gql`
  mutation UpdateTeacherNote($id: ID!, $text: String!) {
    updateTeacherNote(id: $id, text: $text) { ${TEACHER_NOTE_FIELDS} }
  }
`;
export const DELETE_TEACHER_NOTE_MUTATION = gql`
  mutation DeleteTeacherNote($id: ID!) { deleteTeacherNote(id: $id) }
`;
export const MY_TEACHER_NOTES_QUERY = gql`
  query MyTeacherNotes($lang: String) {
    myTeacherNotes(lang: $lang) { ${TEACHER_NOTE_FIELDS} }
  }
`;
export const NOTE_LESSON_QUERY = gql`
  query NoteLesson($id: ID!) { noteLesson(id: $id) { status lessonData error } }
`;
export const START_NOTE_LESSON_MUTATION = gql`
  mutation StartNoteLesson($id: ID!, $fresh: Boolean) { startNoteLesson(id: $id, fresh: $fresh) { status lessonData error } }
`;
export const STUDENT_SAY_ITEMS_QUERY = gql`
  query StudentSayItems($student: String!, $lang: String!) {
    studentSayItems(student: $student, lang: $lang) { ${SAY_ITEM_FIELDS} }
  }
`;
export const MY_SAY_ITEMS_QUERY = gql`
  query MySayItems($lang: String) { mySayItems(lang: $lang) { ${SAY_ITEM_FIELDS} } }
`;
export const ADD_SAY_ITEM_MUTATION = gql`
  mutation AddSayItem($text: String!, $lang: String!, $sourceLang: String) {
    addSayItem(text: $text, lang: $lang, sourceLang: $sourceLang) { ${SAY_ITEM_FIELDS} }
  }
`;
export const DELETE_SAY_ITEM_MUTATION = gql`
  mutation DeleteSayItem($id: ID!) { deleteSayItem(id: $id) }
`;

// ── A Skill Tree lesson's saved answers ─────────────────────────────────────
// Kept apart from homework: saved only when the learner chooses, and shared
// only with the teachers they tick (and only teachers of that language).
const LESSON_WORK_FIELDS = `id student meetingId title language answers { index prompt text } savedAt updatedAt sharedAt sharedWith comment commentBy reviewedAt`
export const MY_LESSON_WORK_QUERY = gql`
  query MyLessonWork($meetingId: ID!) { myLessonWork(meetingId: $meetingId) { ${LESSON_WORK_FIELDS} } }
`
export const SAVE_LESSON_WORK_MUTATION = gql`
  mutation SaveLessonWork($meetingId: ID!, $answers: [SpeakingAnswerInput!]!, $shareWith: [String!]) {
    saveLessonWork(meetingId: $meetingId, answers: $answers, shareWith: $shareWith) { ${LESSON_WORK_FIELDS} }
  }
`
export const DELETE_LESSON_WORK_MUTATION = gql`
  mutation DeleteLessonWork($meetingId: ID!) { deleteLessonWork(meetingId: $meetingId) }
`
export const LESSON_WORK_FOR_ME_QUERY = gql`
  query LessonWorkForMe($limit: Int) { lessonWorkForMe(limit: $limit) { ${LESSON_WORK_FIELDS} } }
`
export const COMMENT_LESSON_WORK_MUTATION = gql`
  mutation CommentLessonWork($workId: ID!, $comment: String!) {
    commentLessonWork(workId: $workId, comment: $comment) { id comment commentBy reviewedAt }
  }
`

// A lesson explained in the learner's own language (translated on the Mac
// Studio, kept on the server). status: original | none | generating | ready | failed.
export const LESSON_TRANSLATION_QUERY = gql`
  query LessonTranslation($m: ID!, $l: String!) { lessonTranslation(meetingId: $m, lang: $l) { status lang sourceLang lessonData error } }
`
export const TRANSLATE_LESSON_MUTATION = gql`
  mutation TranslateLesson($m: ID!, $l: String!) { translateLesson(meetingId: $m, lang: $l) { status lang sourceLang lessonData error } }
`

// A skill-tree topic's lesson, written on the server: the one that fits the
// learner's own language (or, with student, a student of mine), written if
// there isn't one yet — poll TOPIC_LESSON_QUERY while it's "generating".
export const START_TOPIC_LESSON_MUTATION = gql`
  mutation StartTopicLesson($topicId: ID!, $student: String, $fresh: Boolean) {
    startTopicLesson(topicId: $topicId, student: $student, fresh: $fresh) { status meetingId error }
  }
`;
export const TOPIC_LESSON_QUERY = gql`
  query TopicLesson($topicId: ID!, $student: String) {
    topicLesson(topicId: $topicId, student: $student) { status meetingId error }
  }
`;
// My own version of a topic's lesson, from my profile, private to me.
export const START_PERSONAL_LESSON_MUTATION = gql`
  mutation StartPersonalLesson($topicId: ID!, $fresh: Boolean) {
    startPersonalLesson(topicId: $topicId, fresh: $fresh) { status meetingId error }
  }
`;
export const PERSONAL_LESSON_QUERY = gql`
  query PersonalLesson($topicId: ID!) {
    personalLesson(topicId: $topicId) { status meetingId error }
  }
`;

// ─── Speaking homework (server: schema/speaking.js) ────────────────────────
const SPEAKING_FIELDS = `
  id lang title meaning teacher due seconds status error source createdAt
  topics { index title meaning questions { text meaning } notes status error lines { said meaning } }
`

export const MY_SPEAKING_TASKS_QUERY = gql`
  query MySpeakingTasks { mySpeakingTasks { ${SPEAKING_FIELDS} progress } }
`
export const SPEAKING_TASK_QUERY = gql`
  query SpeakingTask($id: ID!) { speakingTask(id: $id) { ${SPEAKING_FIELDS} progress } }
`
export const START_SPEAKING_TASK_MUTATION = gql`
  mutation StartSpeakingTask($lang: String!, $text: String!, $teacher: String, $due: String) {
    startSpeakingTask(lang: $lang, text: $text, teacher: $teacher, due: $due) { ${SPEAKING_FIELDS} }
  }
`
export const WRITE_SPEAKING_PART_MUTATION = gql`
  mutation WriteSpeakingPart($id: ID!, $topic: Int!, $notes: String!) {
    writeSpeakingPart(id: $id, topic: $topic, notes: $notes) { ${SPEAKING_FIELDS} }
  }
`
export const EDIT_SPEAKING_PART_MUTATION = gql`
  mutation EditSpeakingPart($id: ID!, $topic: Int!, $text: String!) {
    editSpeakingPart(id: $id, topic: $topic, text: $text) { ${SPEAKING_FIELDS} }
  }
`
export const DELETE_SPEAKING_TASK_MUTATION = gql`
  mutation DeleteSpeakingTask($id: ID!) { deleteSpeakingTask(id: $id) }
`
export const RECORD_SPEAKING_RESULTS_MUTATION = gql`
  mutation RecordSpeakingResults($taskId: ID!, $results: [SpeakingResultInput!]!) {
    recordSpeakingResults(taskId: $taskId, results: $results) { taskId pct linesKnown linesTotal }
  }
`

// ─── Practice homework (server: schema/study.js) ───────────────────────────
const STUDY_FIELDS = `
  id lang title meaning summary teacher due status error source note createdAt
  fixes { said better meaning why }
  points { title explanation examples { said meaning } }
  exercises { sentence answer options meaning why }
`

export const MY_STUDY_TASKS_QUERY = gql`
  query MyStudyTasks { myStudyTasks { ${STUDY_FIELDS} } }
`
export const STUDY_TASK_QUERY = gql`
  query StudyTask($id: ID!) { studyTask(id: $id) { ${STUDY_FIELDS} } }
`
export const START_STUDY_TASK_MUTATION = gql`
  mutation StartStudyTask($lang: String!, $text: String!, $note: String, $teacher: String, $due: String) {
    startStudyTask(lang: $lang, text: $text, note: $note, teacher: $teacher, due: $due) { ${STUDY_FIELDS} }
  }
`
export const REMAKE_STUDY_TASK_MUTATION = gql`
  mutation RemakeStudyTask($id: ID!, $note: String) { remakeStudyTask(id: $id, note: $note) { ${STUDY_FIELDS} } }
`
export const DELETE_STUDY_TASK_MUTATION = gql`
  mutation DeleteStudyTask($id: ID!) { deleteStudyTask(id: $id) }
`

// ── Sentence builder: say it in your own language, build it in blocks ───────
const SENTENCE_BUILD_FIELDS = `
  id lang text status error sentence meaning tip map saved createdAt
  blocks { role said meaning base note options dropped }
  variations { said meaning note }
`
export const MY_SENTENCE_BUILDS_QUERY = gql`query MySentenceBuilds($lang: String, $limit: Int) { mySentenceBuilds(lang: $lang, limit: $limit) { ${SENTENCE_BUILD_FIELDS} } }`
export const SENTENCE_BUILD_QUERY = gql`query SentenceBuild($id: ID!) { sentenceBuild(id: $id) { ${SENTENCE_BUILD_FIELDS} } }`
export const SENTENCE_MAP_QUERY = gql`query SentenceMap($lang: String!) { sentenceMap(lang: $lang) }`
export const START_SENTENCE_BUILD_MUTATION = gql`mutation StartSentenceBuild($lang: String!, $text: String!) { startSentenceBuild(lang: $lang, text: $text) { ${SENTENCE_BUILD_FIELDS} } }`
export const SAVE_SENTENCE_BUILD_MUTATION = gql`mutation SaveSentenceBuild($id: ID!) { saveSentenceBuild(id: $id) { id saved } }`
export const DELETE_SENTENCE_BUILD_MUTATION = gql`mutation DeleteSentenceBuild($id: ID!) { deleteSentenceBuild(id: $id) }`

// The learner's phrases in a language — the deck the Big screen practises
// (the same as the Apple TV's: TVPhrase.load).
export const GET_MY_PHRASES_QUERY = gql`
  query GetMyPhrases($lang: String!, $limit: Int) {
    getMyPhrases(lang: $lang, limit: $limit) {
      id
      text
      lang
      itemType
      translationText
      translationLang
    }
  }
`

// A conversation turn with real speaker roles (Language Partner on the Big
// screen, as on the Apple TV: Shared/PartnerModel.swift).
export const CHAT_MUTATION = gql`
  mutation Chat($messages: [ChatMessageInput!]!, $model: String, $maxTokens: Int, $json: Boolean, $temperature: Float) {
    chat(messages: $messages, model: $model, maxTokens: $maxTokens, json: $json, temperature: $temperature) { text }
  }
`

// Life's home (UI/LifeHome.js): what you've had, newest first.
export const GET_CONSUMPTIONS_QUERY = gql`
  query GetConsumptions($input: ConsumptionQueryInput) {
    getConsumptions(input: $input) {
      identity
      properties { name amount units time kind good emoji }
    }
  }
`

// A project's flow (the Work app's Flow, on the website): every task, which
// comes before which, and who's arranging it now. The version is cheap, for
// following changes made on the iPad every second or two.
export const GET_PROJECT_FLOW_QUERY = gql`
  query GetProjectFlow($project: String!) {
    getProjectFlow(project: $project) {
      project version editor editedAt
      links { from to }
      tasks {
        identity status
        properties { title priority assignee timeBudget timeSpent dueDate username project personal inFlow parentId }
      }
    }
  }
`
export const GET_FLOW_VERSION_QUERY = gql`
  query GetFlowVersion($project: String!) { getFlowVersion(project: $project) }
`

// A task's checklist (the Work app's subtasks): a new one in a task.
export const ADD_SUBTASK_MUTATION = gql`
  mutation AddSubtask($parentId: ID!, $title: String!) {
    addSubtask(parentId: $parentId, title: $title) { identity properties { title parentId } }
  }
`

// Arranging a project's flow (as the Work app does on the iPad).
const FLOW_FIELDS = `project version editor editedAt links { from to } tasks { identity status properties { title priority assignee timeBudget timeSpent dueDate username project personal inFlow parentId } }`
export const SET_FLOW_LINKS_MUTATION = gql`
  mutation SetFlowLinks($project: String!, $links: [FlowLinkInput!]!) { setFlowLinks(project: $project, links: $links) { ${FLOW_FIELDS} } }
`
export const SET_FLOW_MEMBERSHIP_MUTATION = gql`
  mutation SetFlowMembership($project: String!, $taskIds: [ID!]!, $inFlow: Boolean!) { setFlowMembership(project: $project, taskIds: $taskIds, inFlow: $inFlow) { ${FLOW_FIELDS} } }
`
export const UNLINK_TASKS_MUTATION = gql`
  mutation UnlinkTasks($project: String!, $before: ID!, $after: ID!) { unlinkTasks(project: $project, before: $before, after: $after) { ${FLOW_FIELDS} } }
`
export const ARRANGING_FLOW_MUTATION = gql`
  mutation ArrangingFlow($project: String!) { arrangingFlow(project: $project) }
`

// One prompt on the Mac Studio, through the server (schema/generate.js).
export const GENERATE_MUTATION = gql`
  mutation Generate($prompt: String!, $maxTokens: Int, $json: Boolean) {
    generate(prompt: $prompt, maxTokens: $maxTokens, json: $json) { text model }
  }
`

// Making tasks from what was said in the flow's tray (UI/FlowAddTasks.js).
export const QUICK_ADD_TASK_MUTATION = gql`
  mutation QuickAddTask($title: String!, $type: String!, $description: String, $position: String!, $priority: String!,
    $assignee: String, $timeBudget: Float, $timeSpent: Float, $dueDate: DateTime!, $username: String!, $project: String) {
    addTask(input: { title: $title, type: $type, description: $description, position: $position, priority: $priority,
      assignee: $assignee, timeBudget: $timeBudget, timeSpent: $timeSpent, dueDate: $dueDate, username: $username, project: $project }) {
      identity
      properties { title }
    }
  }
`

// Questions students asked about a sentence while practising (server: schema/phraseHelp.js).
export const PHRASE_QUESTIONS_FOR_ME_QUERY = gql`
  query PhraseQuestionsForMe($limit: Int) {
    phraseQuestionsForMe(limit: $limit) { id student lang text meaning question askedAt comment commentBy reviewedAt }
  }
`
export const ANSWER_PHRASE_QUESTION_MUTATION = gql`
  mutation AnswerPhraseQuestion($id: ID!, $comment: String!) {
    answerPhraseQuestion(id: $id, comment: $comment) { id comment commentBy reviewedAt }
  }
`

// Practice homework for the Big screen: the list with how much is known, and one's phrases.
export const MY_STUDY_HOMEWORK_QUERY = gql`
  query MyStudyHomework { myStudyTasks { id lang title due status progress } }
`
export const STUDY_TASK_PHRASES_QUERY = gql`
  query StudyTaskPhrases($id: ID!) { studyTask(id: $id) { id lang phrases { id text translation sentenceId order } } }
`
